import React, { Suspense } from 'react';

const Modal = React.lazy(() =>
  import('mondrian-react').then(({ Modal }) => ({
    default: Modal,
  })),
);
const Heading = React.lazy(() =>
  import('mondrian-react').then(({ Heading }) => ({
    default: Heading,
  })),
);
const Text = React.lazy(() =>
  import('mondrian-react').then(({ Text }) => ({
    default: Text,
  })),
);
const Button = React.lazy(() =>
  import('mondrian-react').then(({ Button }) => ({
    default: Button,
  })),
);
interface Props {
  show: boolean;
  message: string;
  onClose: () => void;
}

export function WarningModal({ show, message, onClose }: Props) {
  return (
    <>
      <Suspense fallback={<span> </span>}>
        <Modal
          sm
          data={{
            header: <Heading md>Atenção!</Heading>,
            content: (
              <Text body>
                <span dangerouslySetInnerHTML={{ __html: message }} />
              </Text>
            ),
            footer: {
              content: (
                <Button id="btnVoltar" onClick={onClose}>
                  Voltar
                </Button>
              ),
            },
            isOpen: show,
            // onCloseClick: onClose,
            buttonProps: {
              style: {
                display: 'none',
              },
            },
          }}
        />
      </Suspense>
    </>
  );
}
